import React from 'react'
import { RecepcaoContrato } from '@newspacebpo/mf_protocolo_bfveic'
const RecepcaoContratoPage = (props) => {
    return (
            <RecepcaoContrato {...props}/>
    );
};

export { RecepcaoContratoPage };